import * as React from 'react';
import * as RX from 'reactxp';

import { colors } from '../../../utils/styles';

// tslint:disable:max-line-length
class Chevron extends React.Component<{color: string }> {

  constructor(props) {
    super(props);
  }

  public render() {
    const { color = colors.menuBlue } = this.props;

    return (
      <svg width='11' height='7' viewBox='-300 393 11 7'>
        <path fill={color} d='M-293.7,399.1l3.9-4.6c0.3-0.3,0.3-0.9,0-1.2l-0.1-0.1c-0.3-0.3-0.9-0.3-1.2,0l-3.6,3l-3.8-2.7	c-0.3-0.3-0.9-0.3-1.2,0.1l-0.1,0.1c-0.3,0.3-0.3,0.9,0.1,1.2l4.3,4.2C-294.9,399.6-294.2,399.6-293.7,399.1z'/>
      </svg>
    );
  }
}

export default Chevron;



// WEBPACK FOOTER //
// ./src/modules/svgs/chevron/index.web.tsx